import { useContext } from "react";
import { useState, useEffect } from "react";
import { AuthContext } from "../../../context/authContext";
import { SocketContext } from "../../../context/socketContext";

export const useSendMessage = ({ sendMessage, clearAttachments, setText }) => {
    const [isSending, setIsSending] = useState(false);
    const [cooldown, setCooldown] = useState(0);

    const { publicKey } = useContext(AuthContext);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        let timer;
        if (cooldown > 0) {
            timer = setInterval(() => setCooldown((prev) => prev - 1), 1000);
        }
        return () => clearInterval(timer);
    }, [cooldown]);

    const handleSend = async (text, currentReceiver, attachments) => {
        if (isSending || cooldown > 0 || (!text.trim() && attachments.length === 0)) return;
        
        setIsSending(true);

        try {
            const filesToSend = attachments.map(att => att.file);
            const savedMessage = await sendMessage(text, currentReceiver.id, filesToSend, publicKey);

            if (socket) {
                socket.emit("sendMessage", {
                    ...savedMessage, 
                    receiverId: currentReceiver.id 
                });
            }
            
            setText("");
            clearAttachments();
        } catch (err) {
            console.error("Error sending message:", err);
            
            if (err.response?.status === 429) {
                alert("You're texting too fast. Please slow down!");
                setCooldown(15); 
            } else if (err.response?.status === 409) {
                alert("Please refrain from submitting duplicate content repeatedly.");
                setCooldown(5);
            }
        } finally {
            setIsSending(false);
        }
    };

    return {
        isSending,
        cooldown,
        handleSend
    };
};